<template>
  <v-card border>
    <v-card-title class="pt-12 pb-2 pl-4 bg-blue">
      <span class="text-white">
        {{ $t('acquisition-booster.title') }}
      </span>
    </v-card-title>

    <div class="invitation__disabled">
      <div
        v-if="!canSendEmail"
        class="invitation__disabled-content"
      >
        <v-alert
          type="info"
          class="mx-2"
        >
          {{ $t('acquisition-booster.invitation.acquisition-booster-disabled') }}
        </v-alert>
      </div>
      <v-card-text
        v-if="isHoppermationActivated"
        class="py-2"
      >
        <span class="font-weight-bold">
          {{ $t('acquisition-booster.invitation.body-texts.0') }} </span
        ><br />
        <p>{{ $t('acquisition-booster.invitation.body-texts.1', { leadName }) }}</p>
        <InvitationTopicSelect
          v-model.lazy="landingpageSlug"
          :disabled="!canSendEmail"
          :lead-id="lead.id"
        />
        <span class="font-weight-bold">
          {{ $t('acquisition-booster.invitation.body-texts.2') }}
        </span>
        <br />
        <p class="mb-0">
          {{ $t('acquisition-booster.invitation.body-texts.3', { leadName }) }}
        </p>
      </v-card-text>

      <v-card-text
        v-else
        class="pt-2 font-weight-bold"
      >
        {{ $t('acquisition-booster.invitation.body-texts.4') }}
      </v-card-text>

      <v-card-actions class="d-flex flex-column pt-0">
        <InvitationButton
          :lead-ids="[lead.id]"
          :landingpage-slug="landingpageSlug"
          :is-lead-deleted-by-crm-provider="isLeadDeletedByCrmProvider"
          :delay="3000"
          @invitationSent="invitationSent"
        />

        <InvitationPreview :landingpage-slug="landingpageSlug" />
      </v-card-actions>
    </div>
  </v-card>
</template>
<script>
import MAIL_PROVIDER from '@/modules/leads/queries/MailProvider.gql'

import InvitationButton from './InvitationButton.vue'
import InvitationPreview from './InvitationPreview.vue'
import InvitationTopicSelect from './InvitationTopicSelect.vue'

export default {
  components: { InvitationPreview, InvitationButton, InvitationTopicSelect },
  props: {
    lead: { type: Object, default: null },
    isLeadDeletedByCrmProvider: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      landingpageSlug: null,
    }
  },
  computed: {
    isHoppermationActivated() {
      return this.mailProvider === 'HOPPERMATION'
    },
    canSendEmail() {
      const channels = this.lead.channels ?? []
      const hasActiveChannel =
        channels.length === 0 ||
        channels.some(
          (channel) => channel.subscribedAt && !channel.unsubscribedAt && !channel.pausedAt
        )
      return this.lead.isDataProcessingPermissionGranted === true && hasActiveChannel
    },
    leadName() {
      return this.lead.firstname || this.lead.lastname
        ? `${this.lead.firstname} ${this.lead.lastname}`
        : this.lead.email
    },
  },
  methods: {
    invitationSent() {
      this.landingpageSlug = null
    },
  },
  watch: {
    landingpageSlug: {
      handler(value) {
        this.$tracking.event('Lead', 'Selected', 'Topic', value)
      },
    },
  },
  apollo: {
    mailProvider: {
      query: MAIL_PROVIDER,
      variables() {
        return {
          companyId: this.$auth.user.companyId,
        }
      },
      update: (data) => data.company.mailProvider,
    },
  },
}
</script>
<style scoped>
.invitation__disabled {
  position: relative;
}
.invitation__disabled-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(2px);
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
